import { render, staticRenderFns } from "./setup-office-expedition.vue?vue&type=template&id=6a4c43c3&"
import script from "./setup-office-expedition.vue?vue&type=script&lang=js&"
export * from "./setup-office-expedition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports